import React from "react"
import { CircleDollarSign } from "lucide-react"

const ContactValueIcon: React.FC<React.ComponentProps<typeof CircleDollarSign>> = (props) => (
	<CircleDollarSign
		size={24}
		{...props}
	/>
)

export default ContactValueIcon
